import "antd/dist/reset.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { AppRoutes } from "./components/navigation/AppRoutes";
import { CustomOidcProvider } from "./components/navigation/oidc/CustomOidcProvider";
import { LoadingComponent } from "./components/navigation/oidc/LoadingComponent";
import { OidcWorkerGate } from "./components/navigation/oidc/OidcWorkerGate";
import "./index.css";
import configuredStore from "./store/configureStore";

// Get the application-wide store instance, prepopulating with state from the server where available.
const { store, persistor } = configuredStore();

const rootElement = document.getElementById("root");

// create a root
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <BrowserRouter basename={`${process.env.REACT_APP_BASENAME}`}>
      <OidcWorkerGate>
        <CustomOidcProvider>
          <PersistGate
            loading={<LoadingComponent type={3} />}
            persistor={persistor}
          >
            <AppRoutes />
          </PersistGate>
        </CustomOidcProvider>
      </OidcWorkerGate>
    </BrowserRouter>
  </Provider>
);
